import { render, staticRenderFns } from "./detail_mobile.vue?vue&type=template&id=4ae8190f&scoped=true&"
import script from "./detail_mobile.vue?vue&type=script&lang=js&"
export * from "./detail_mobile.vue?vue&type=script&lang=js&"
import style0 from "./detail_mobile.vue?vue&type=style&index=0&id=4ae8190f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae8190f",
  null
  
)

export default component.exports